export interface AssistantContext {
  app: string;
  item_type?: string;
  item_id?: string;
  surface?: string;
}

/**
 * Reads the current app context from the window global set by each app module.
 * Falls back to inferring the app from the URL pathname.
 *
 * Safe to call outside of React (e.g., inside chatApi.ts before a fetch).
 */
export function resolveCurrentContext(): AssistantContext | null {
  // Option 1: app module set window.__wecoContext explicitly
  const wc = (window as unknown as { __wecoContext?: AssistantContext }).__wecoContext;
  if (wc?.app) return wc;

  // Option 2: infer app from pathname
  const path = window.location.pathname;
  if (path.startsWith("/email")) return { app: "email", surface: "drawer" };
  if (path.startsWith("/planner") || path.startsWith("/calendar")) return { app: "calendar", surface: "drawer" };
  if (path.startsWith("/vault") || path.startsWith("/drive")) return { app: "drive", surface: "drawer" };
  if (path.startsWith("/write") || path.startsWith("/docs")) return { app: "docs", surface: "drawer" };
  if (path.startsWith("/call") || path.startsWith("/video")) return { app: "video", surface: "drawer" };
  if (path.startsWith("/chat")) return { app: "chat", surface: "drawer" };

  return null;
}
